import { Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { ComunicacionapiService } from './comunicacionapi.service';
import { Constantes } from '../models/modules/Constantes';
import { Listas } from '../models/generic/Listas';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService {
  
  ListasSistema: Listas[] = [];
    
  constructor(private configInicial: ConfiguracionInicialService,
    private comunicacionapiService: ComunicacionapiService) {
      
  }

  CargarListas(parametros: any) {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.CONFIGURACION_LISTAS()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
}
